import { AxiosInstance } from 'axios';
import { BackendVersion, ChangelogResponse } from './version.types';

export const createVersionApi = (api: AxiosInstance) => ({
  getBackendVersion: () =>
    api.get<BackendVersion>('/version').then((r) => r.data),
  getChangelog: () =>
    api.get<ChangelogResponse>('/version/changelog').then((r) => r.data),
});
